<template>
  <div>
    <div class="member_tabbar">
      <a href="javascript:;" :class="{'active': curTitle == 3}" @click="changeTitle(3)">培训<i></i></a>
      <a href="javascript:;" :class="{'active': curTitle == 1}" @click="changeTitle(1)">课程<i></i></a>
      <!-- <a href="javascript:;" :class="{'active': curTitle == 2}" @click="changeTitle(2)">考试<i></i></a> -->
    </div>
    <div class="task_state">
      <a href="javascript:;" v-for="item in stateList" @click="changeState(item.state)" :class="{'active': item.isCur}">{{item.name}}<i></i></a>
    </div>
    <div class="task_list" v-loading="loading">
      <ul  class="clearfix">
        <li v-for="task in taskListHandl" :key="`task${task.taskId}`" >
          <div style="cursor: pointer;" @click="taskClick(task)">
            <h3>{{task.taskName}}</h3>
            <p><span class="state">{{task.stateStr}}</span> ｜ <span>{{task.score}}学分</span> ｜ <span>结束时间：{{task.timeStr}}</span> ｜ <span class="progress">{{task.rate}}%</span></p>
          </div>
        </li>
<!--        <li>
          <a href="javascrpt;;">
          <h3>“十三五”时期我国经济社会发展成就与经验启示</h3>
          <p><span class="state">未完成</span> ｜ <span>26学分</span> ｜ <span>结束时间：永久有效</span> ｜ <span class="progress">5%</span></p>
          </a>
        </li>
        <li>
          <a href="javascrpt;;">
          <h3>粮食安全如何保障</h3>
          <p><span class="state">未完成</span> ｜ <span>26学分</span> ｜ <span>结束时间：永久有效</span> ｜ <span class="progress">5%</span></p>
          </a>
        </li> -->
      </ul>

      <div class="task-pagination" style="text-align: center;" v-show="listlength">
        <el-pagination
              @current-change="handleCurrentChange"
              :current-page.sync="pageNum"
              :page-size="pageSize"
              layout="prev, pager, next, jumper"
              :total="total">
            </el-pagination>
      </div>
      <nothing v-show="listlength == 0"></nothing>
    </div>
  </div>
</template>

<script>
import '../../assets/css/member.css'
import {ApiGetTaskList} from '../../net/accound/index.js'
import {setCookie} from '../../untils/common.js'
import nothing from '../../common/nothing.vue'
export default {
  data: function () {
    return {
      curTitle: 3, //  1 课程   2考试  3混合培训
      curState: 1, // 1未完成   2已完成   3已过期
      pageNum: 1,
      pageSize	: 10,
      total: 0,
      taskList: [],
      loading: false,
    }
  },
  components:{nothing},
  computed: {
    taskListHandl: function () {
      return this.taskList.map(item=>{
        const stateArr = ['', '未完成', '已完成', '已过期']
         return {
           ...item,
           timeStr: item.isForever == 2?'永久有效': item.finalTime,
           stateStr: stateArr[item.queryStatus]
         }
      })
    },
    listlength: function () {
      return this.taskList.length
    },
    stateList: function () {
      return [
                {state: 1, isCur: this.curState == 1, name: '未完成'},
                {state: 2, isCur: this.curState == 2, name: '已完成'},
                {state: 3, isCur: this.curState == 3, name: '已过期'},
             ]
    }
  },
  methods:{
    changeTitle: function (curTitle) {
      this.curTitle = curTitle
      this.pageNum = 1
      this.curState = 1
      this.getTaskList()
    },
    changeState: function (state) {
      this.curState = state
      this.pageNum = 1
      this.getTaskList()
    },
    getTaskList: function () {
      const prames = {
        taskType: this.curTitle,
        courseTaskStatus: this.curState,
        trainTaskStatus: this.curState,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        platform: 'pc'
      }
      this.loading = true
      ApiGetTaskList(prames).then(res=>{
         // console.log('任务列表', res)
         if (res.code == 200) {
           this.taskList = res.pc.details
           this.total = res.pc.total
         }
        this.loading = false
      }).catch(err=>{
        this.loading = false
      })
    },
    handleCurrentChange: function (index) {
      this.pageNum = index
      this.getTaskList()
    },
    taskClick: function (task) {
      if (task.queryStatus == 3) {
        this.$message('该任务已过期')
        return
      }
      switch(task.taskType){
        case 1: // 课程
          this.toCourseDetail(task.courseId)
          break
        case 2: // 考试
          this.toPlanDetail(task.taskId)
          break
        case 3: // 培训
          this.toPlanDetail(task.taskId)
          break
      }
    },
    toCourseDetail: function (id) {
      this.$router.push({
          path : 'CourseDetail',
          query : {id : id},
      })
    },
    toPlanDetail: function (id) {
      setCookie('frompage1','Accound')
      this.$router.push({
          path : 'PlanDetail',
          query : {id : id},
      })
    }
  },
  mounted: function () {
    this.getTaskList()
  }
}
</script>

<style scoped>
  .task_list{
    position: relative;
  }
.task-pagination{
  text-align: center;
  position: absolute;
  bottom: 20px;
  width: 100%;
  left: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/AccStudyPlan/AccStudyPlan.vue